import React, { useState, useEffect } from "react";
import { FaPhone, FaCalculator, FaBullseye, FaComments, FaFolderOpen } from "react-icons/fa";
import Tools from '../utils/Tools';

function IntentsTiles({ intents, totalCalls, totalIntentCount }) {
  const [tiles, setTiles] = useState([]);

  useEffect(() => {
    const minorIntentCount = intents.reduce(
      (sum, intent) => sum + (intent.minorIntents.length || 0),
      0
    );
    const uniqueCategoriesCount = new Set(intents.map((obj) => obj.category))
      .size;

    // Update tiles based on allAgentInfo
    setTiles([
      { Icon: FaPhone, title: "Total Calls", value: Tools.formatNumber(totalCalls || 0) },
      { Icon: FaCalculator, title: "Total Intent Count", value: Tools.formatNumber(totalIntentCount || 0) },
      {
        Icon: FaFolderOpen,
        title: "Categories",
        value: Tools.formatNumber(uniqueCategoriesCount || 0),
      },
      {
        Icon: FaBullseye,
        title: "Unique Intents",
        value: Tools.formatNumber(intents.length || 0),
      },
      {
        Icon: FaComments,
        title: "Minor Intents",
        value: Tools.formatNumber(minorIntentCount || 0),
      },

      // Add more tiles as needed, using data from allAgentInfo
    ]);
  }, [intents, totalCalls, totalIntentCount]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mb-8">
      {tiles.map((tile, index) => (
        <div
          key={index}
          className="bg-indigo-700 text-white p-4 rounded-xl shadow-lg flex items-center justify-between h-24 transition-all duration-300 hover:shadow-xl hover:scale-105"
        >
          <div className="flex flex-col items-center flex-grow">
            <div className="flex items-center">
              <p className="text-4xl font-bold">{tile.value}</p>
              {tile.trend && <span className="ml-2">{tile.trend}</span>}
            </div>
            <h3 className="text-sm font-semibold uppercase tracking-wide mt-1">
              {tile.title}
            </h3>
          </div>
          <tile.Icon className="text-4xl opacity-70 ml-4" />
        </div>
      ))}
    </div>
  );
}

export default IntentsTiles;
